import axios from './axios';

function responseMessage(data) {
  if (typeof data === 'string' && data.trim()) return data.trim();
  if (!data || typeof data !== 'object') return '';
  if (typeof data.message === 'string' && data.message.trim()) return data.message.trim();
  if (typeof data.error === 'string' && data.error.trim()) return data.error.trim();
  return '';
}

export class LogoutError extends Error {
  constructor(message = 'Logout failed') {
    super(message);
    this.name = 'LogoutError';
  }
}

export async function logoutSession({ client = axios, authType = null } = {}) {
  let response;

  try {
    response = await client.post('/api/auth/logout', authType ? { authType } : null, {
      withCredentials: true,
      validateStatus: () => true
    });
  } catch (error) {
    throw new LogoutError(responseMessage(error?.response?.data) || error?.message);
  }

  const status = Number(response?.status);
  const explicitlyFailed = response?.data &&
    typeof response.data === 'object' &&
    response.data.success === false;

  if (!Number.isFinite(status) || status < 200 || status >= 300 || explicitlyFailed) {
    throw new LogoutError(responseMessage(response?.data));
  }

  return response;
}
